import { create, tsx } from '@dojo/framework/core/vdom';
import { Summary } from './Summary';

import * as css from './WhySitePen.m.css';
import { RenderResult } from '@dojo/framework/core/interfaces';
import SitePenLogo from './SitepenLogo';

interface WhySitePenProperties {
	reverse?: boolean;
}

interface WhySitePenChildren {
	title?: RenderResult;
	blurb?: RenderResult;
}

const DefaultBlurb = create()(function DefaultWhySitePenBlurb() {
	return (
		<virtual>
			<p>
				At SitePen, we believe that quality is the single, most important aspect of any
				project we undertake. Our commitment to delivering bug-free solutions infuses every
				part of our development activities.
			</p>
			<p>
				You will start to experience this as soon as you reach out to us. Our Sales and
				Project Management teams work with you to understand your goals and expectations,
				identifying the characteristics that have the most significant influence on the
				application's quality.
			</p>
			<p>
				Our engineering team will then develop the solution with these goals in mind. They
				also create extensive suites of automated tests that ensure that the code continues
				to work as intended. Finally, we continuously monitor the project in search of
				refactoring opportunities to improve the code's structure as it evolves. While not
				usually considered an essential aspect of quality assurance, we have found that
				superior code organization often leads to exceptional quality in the final product.
			</p>
		</virtual>
	);
});

const factory = create()
	.properties<WhySitePenProperties>()
	.children<WhySitePenChildren | undefined>();

export const WhySitePen = factory(function WhySitePen({ properties, children }) {
	const { reverse = false } = properties();
	const defaultTitle = 'Why Develop with SitePen';
	const [
		{ title = defaultTitle, blurb = <DefaultBlurb /> } = {
			title: defaultTitle,
			blurb: <DefaultBlurb />
		}
	] = children();
	title;
	return (
		<Summary collapse="large" reverse={reverse} imageGutter="large">
			{{
				title,
				blurb,
				image: (
					<div classes={[css.image, reverse && css.reverse]}>
						<SitePenLogo />
					</div>
				)
			}}
		</Summary>
	);
});

export default WhySitePen;
